"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _queryString = require("query-string");

var _constants = require("../constants");

var _RootStore = _interopRequireDefault(require("../store/RootStore.js"));

var _TapLoader = _interopRequireDefault(require("./TapLoader"));

require("../assets/css/style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var GoSell = /*#__PURE__*/function (_Component) {
  _inherits(GoSell, _Component);

  var _super = _createSuper(GoSell);

  function GoSell(props) {
    var _this;

    _classCallCheck(this, GoSell);

    _this = _super.call(this, props);
    _this.state = {
      tap_id: null,
      config: {}
    };
    return _this;
  }

  _createClass(GoSell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      GoSell.showResult(this.props);
      setTimeout(function () {
        var iframe = document.getElementById("gosell-gateway");
        iframe && iframe.addEventListener("load", function () {
          setTimeout(function () {
            _RootStore["default"].uIStore.setLoader(false);
          }, 500);
        });
      }, 100);
      this.callbacks();
    }
  }, {
    key: "callbacks",
    value: function callbacks() {
      var self = this; // Create IE + others compatible event handler

      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message"; // Listen to message from child window

      eventer(messageEvent, function (e) {
        // console.log("event", e.data);
        if (e.data.callback) {
          if (self.props && self.props.callback && self.props.callback != null) {
            self.props.callback(e.data);
          } else {
            _RootStore["default"].configStore.callbackFunc(e.data);
          }
        }

        if (e.data == "close" || e.data.close) {
          console.log("close it");

          _RootStore["default"].uIStore.setOpenModal(false);

          self.setState({
            config: {}
          });
          self.props = {};
          _RootStore["default"].configStore.gateway.onClose ? _RootStore["default"].configStore.gateway.onClose() : null;
          e.data == "close" ? self.closeModal(_RootStore["default"].configStore.redirect_url) : self.closeModal(e.data.close);
        }
      }, false);
    }
  }, {
    key: "closeModal",
    value: function closeModal(closeUrl) {
      var urlParams = (0, _queryString.parse)(window.location.search);
      var tapId = urlParams.tap_id;

      if (tapId) {
        window.open(closeUrl, "_self");
      }

      var body = document.getElementsByTagName("BODY")[0];
      body.classList.remove("gosell-payment-gateway-open"); // var iframe = document.getElementById("gosell-gateway");
      // iframe.setAttribute("src", iframe.getAttribute("src"));

      _RootStore["default"].uIStore.setOpenModal(false);

      _RootStore["default"].uIStore.setLoader(true);
    }
  }, {
    key: "componentWillUnMount",
    value: function componentWillUnMount() {
      // Create IE + others compatible event handler
      this.callbacks();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _RootStore["default"].uIStore.modalMode == "popup" && _RootStore["default"].uIStore.openModal ? /*#__PURE__*/_react["default"].createElement("iframe", {
        id: "gosell-gateway",
        style: {
          display: !_RootStore["default"].uIStore.isLoading ? "block" : "none",
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          margin: "auto",
          border: "0px",
          zIndex: "99999999999999999"
        },
        allow: "payment",
        src: _RootStore["default"].uIStore.tap_id != null && _RootStore["default"].configStore.token != null ? _constants.CONFIGS.framePath + "?mode=" + _RootStore["default"].uIStore.modalMode + "&token=" + _RootStore["default"].configStore.token + "&tap_id=" + _RootStore["default"].uIStore.tap_id : _constants.CONFIGS.framePath + "?mode=" + _RootStore["default"].uIStore.modalMode + "&token=" + _RootStore["default"].configStore.token,
        width: "100%",
        height: "100%"
      }) : null, _RootStore["default"].uIStore.openModal ? /*#__PURE__*/_react["default"].createElement(_TapLoader["default"], {
        type: "loader",
        color: "white",
        store: _RootStore["default"],
        status: _RootStore["default"].uIStore.isLoading,
        duration: 5,
        title: null,
        desc: null
      }) : null);
    }
  }], [{
    key: "openLightBox",
    value: //open Tap gateway as a light box by JS library
    function openLightBox() {
      _RootStore["default"].uIStore.setMode("popup");

      _RootStore["default"].uIStore.setOpenModal(true);

      _RootStore["default"].uIStore.setLoader(true);

      var body = document.getElementsByTagName("BODY")[0];
      body.classList.add("gosell-payment-gateway-open");
      setTimeout(function () {
        var iframe = document.getElementById("gosell-gateway");
        iframe && iframe.addEventListener("load", function () {
          setTimeout(function () {
            _RootStore["default"].uIStore.setLoader(false);
          }, 500);
        });
      }, 100);
    } //redirect to Tap gateway from JS library without calling charge / authrorize API from merchant side

  }, {
    key: "openPaymentPage",
    value: function openPaymentPage() {
      _RootStore["default"].uIStore.setMode("page");

      _RootStore["default"].uIStore.setOpenModal(true);

      _RootStore["default"].uIStore.setLoader(true);

      if (_RootStore["default"].configStore.token != null) {
        window.open(_constants.CONFIGS.framePath + "?mode=" + _RootStore["default"].uIStore.modalMode + "&token=" + _RootStore["default"].configStore.token, "_self");
      }
    }
  }, {
    key: "showResult",
    value: function showResult(props) {
      var urlParams = (0, _queryString.parse)(window.location.search);
      var tapId = urlParams.tap_id;
      var pageToken = urlParams.token;
      var pageMode = urlParams.mode;

      if (tapId && pageToken) {
        var callback = null;

        if (props.gateway && props.gateway.callback) {
          callback = props.gateway.callback;
        } else if (props.callback) {
          callback = props.callback;
        }

        _RootStore["default"].configStore.callback = callback;

        _RootStore["default"].uIStore.setMode("popup");

        _RootStore["default"].uIStore.setOpenModal(true);

        _RootStore["default"].uIStore.setLoader(true);

        var body = document.getElementsByTagName("BODY")[0];
        body.classList.add("gosell-payment-gateway-open");
        _RootStore["default"].uIStore.tap_id = tapId;
        _RootStore["default"].configStore.token = pageToken;
        _RootStore["default"].uIStore.modalMode = pageMode;
        setTimeout(function () {
          var iframe = document.getElementById("gosell-gateway");
          iframe && iframe.addEventListener("load", function () {
            // console.log("hey loaded!");
            setTimeout(function () {
              _RootStore["default"].uIStore.setLoader(false);
            }, 500);
          });
        }, 100);
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      // console.log("new props: ", JSON.stringify(nextProps));
      // console.log("old props: ", JSON.stringify(prevState.config));
      // console.log(
      //   "compare props: ",
      //   JSON.stringify(nextProps) != JSON.stringify(prevState.config),
      // );
      if (JSON.stringify(nextProps) != JSON.stringify(prevState.config)) {
        GoSell.config(nextProps);
        prevState.config = nextProps;
      }

      return null;
    }
  }, {
    key: "config",
    value: function config(props) {
      var urlParams = (0, _queryString.parse)(window.location.search);
      var tapId = urlParams.tap_id;

      if (!tapId) {
        _RootStore["default"].configStore.setConfig(props, "GOSELL");
      }
    }
  }]);

  return GoSell;
}(_react.Component);

var _default = (0, _mobxReact.observer)(GoSell);

exports["default"] = _default;